module.exports = __webpack_public_path__ + "img/04-villas.fb3e3912.jpg";